export { default as PromoBadgeLabel } from './PromoBadgeLabel'
